import React from 'react'
import PropTypes from 'prop-types'
import { Svg } from '../../Svg/Svg';

function Checkbox({
  id,
  label,
  name,
  value,
  errorMessage,
  checked,
  onChange,
  isKMI,
  noLabelStyle,
  ...otherProps
}) {

  console.log(isKMI)
  return (
    <div className="mz-form-item mz-form-item--checkbox">
      <label className="mz-form-item__inner" htmlFor={id}>
          {noLabelStyle ?
            <div>{label}</div>
          :
            <div className={!noLabelStyle && 'mz-form-item__label-content'}>{
              isKMI ? 
              <span className="text--white">{label}</span>
              : label
          }</div>
          }
        <input
          type="checkbox"
          className="mz-form-item__checkbox"
          id={id}
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          {...otherProps}
        />
        <div className="mz-form-item__checkmark">
          <Svg
            type="checkmark"
            size={1}
            colour="mz-svg--black"
          />
        </div>
        {errorMessage && (
          <div className="mz-form-item__error-message">{errorMessage}</div>
        )}
      </label>
    </div>
  )
}

Checkbox.propTypes = {
  id: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.array.isRequired
  ]),
  name: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  checked: PropTypes.bool,
  otherProps: PropTypes.object,
}

export default Checkbox